 (function ($) {
	$.submit = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			submit = (function ($c, o) {
				var defaults = {
					'activeClass': 'active',

				}; 

				var _o = {},
					$submit = null
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
				},

				_SubmitClicked = function () {
					$('.cta-button').click(function(e){
						e.preventDefault();
						$('#gform_submit_button_1').trigger('click');
					});
				},

				_BindEvents = function () {
					_SubmitClicked();
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.submit = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('submit')) {
				var plugin = new $.submit(this, options);
				$(this).data('submit', plugin);
			}
		});
	};
})(jQuery);



